import Wordmark from './Wordmark.jsx';
import ExportButtons from './ExportButtons.jsx';

export default function Header({ mode, onModeChange, inputs, rows, summary }) {
  return (
    <header className="sticky top-0 z-30 no-print border-b border-carbon-100/70 bg-white/78 backdrop-blur-2xl">
      <div className="max-w-7xl mx-auto px-6 py-3.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Wordmark />
        </div>

        <div className="flex min-w-0 items-center gap-3">
          <ModeToggle mode={mode} onChange={onModeChange} />
          <span className="hidden md:block w-px h-5 bg-carbon-200" />
          <div className="hidden md:block">
            <ExportButtons mode={mode} inputs={inputs} rows={rows} summary={summary} />
          </div>
        </div>
      </div>
    </header>
  );
}

function ModeToggle({ mode, onChange }) {
  return (
    <div className="inline-flex rounded-full border border-carbon-100 bg-white/90 p-1 text-sm font-medium shadow-sm shadow-carbon-100/70">
      <button
        onClick={() => onChange('simple')}
        className={`px-3.5 py-1.5 rounded-full transition-colors ${
          mode === 'simple'
            ? 'bg-carbon-800 text-white shadow-sm'
            : 'text-carbon-500 hover:text-carbon-800'
        }`}
      >
        Simple
      </button>
      <button
        onClick={() => onChange('detail')}
        className={`px-3.5 py-1.5 rounded-full transition-colors ${
          mode === 'detail'
            ? 'bg-carbon-800 text-white shadow-sm'
            : 'text-carbon-500 hover:text-carbon-800'
        }`}
      >
        Advanced
      </button>
    </div>
  );
}
